import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter, Route } from "react-router-dom"
import { fetchUserData } from "./actions"
import { EmeraldHost, ApplicationHost } from "../../config"
import LargeLoadingNotice from "../../components/LargeLoadingNotice"

const PrivateRoute = ({
  userData,
  strictlyPrivate,
  dispatch,
  fetchAttempted,
  component,
  isFetching,
  componentProps,
  exact,
  path
}) => {
  const handleRouting = routerProps => {
    if (Object.keys(userData).length > 0) {
      return React.createElement(component, Object.assign({}, routerProps, componentProps))
    } else if (fetchAttempted && !isFetching) {
      if (strictlyPrivate) {
        localStorage.setItem("pathToAuthorize", document.location.pathname)
        window.location =
          EmeraldHost() + `login?service=${encodeURIComponent(ApplicationHost() + "users/service")}`
        return <LargeLoadingNotice title={<h1>Loading Login</h1>} />
      } else {
        return React.createElement(component, Object.assign({}, routerProps, componentProps))
      }
    } else {
      if (!isFetching) {
        dispatch(fetchUserData())
      }
      return <LargeLoadingNotice />
    }
  }

  return <Route exact={exact} path={path} render={routerProps => handleRouting(routerProps)} />
}

const { object, bool, string, func, element } = PropTypes
PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([func, object]).isRequired,
  componentProps: object,
  exact: bool,
  path: string,
  userData: object,
  fetchAttempted: bool.isRequired,
  isFetching: bool.isRequired,
  strictlyPrivate: bool
}

PrivateRoute.defaultProps = {
  exact: false,
  path: "",
  componentProps: {},
  strictlyPrivate: true
}

const mapStateToProps = state => {
  let currentUser = state.currentUser || {}
  const { userData, fetchAttempted, isFetching } = {
    userData: currentUser.data || {},
    fetchAttempted: !!currentUser.fetchAttempted,
    isFetching: currentUser.isFetching || false
  }

  return { userData, fetchAttempted, isFetching }
}

export { PrivateRoute }
export default withRouter(connect(mapStateToProps)(PrivateRoute))
